import React from 'react';
import IndividualPackage from './IndividualPackage';

const PackageSearchGrid = (props) => {
    return (
        <div className="land-search-grid">
            <div className="cf">
                {props.data.map((thisPackage) =>
                    <IndividualPackage key={thisPackage.p_id} pkdetails={thisPackage} />
                )}
                <div className="clear-div"></div>
            </div>
        </div>
    );
};

export default PackageSearchGrid;


/** WEBPACK FOOTER **
 ** ./src/modules/house-and-land/elements/PackageSearchGrid.js
 **/